import BannerGeneral from "../../components/BannerGeneral";
import Block2ColumnsText from "../../components/Block2ColumnsText";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockLeftImage from "../../components/BlockLeftImage";
import BlockRightImage from "../../components/BlockRightImage";
import SocialShare from "../../components/SocialShare";

function TecEstrategica() {
  return (
    <>
      <div className="padding ">
        <article class="nota-utpl" lang="es">
          <div className=" padding2 layout6 ">
            <header>
              <center>
                <h2>
                  Estudia una tecnología que
                  <b> transforma la comunicación institucional</b>
                </h2>
                <p className="fontsize14">📲 📩 ❤️</p>
              </center>
            </header>
            <p>
              En el contexto nacional, la comunicación estratégica se ha
              convertido en un eje clave para la gestión institucional en
              Ecuador. El crecimiento acelerado del uso de redes sociales, la
              inmediatez informativa y la alta exposición pública han
              incrementado la vulnerabilidad de organizaciones públicas,
              privadas y sociales frente a crisis reputacionales. Hoy, una
              situación mal gestionada puede escalar rápidamente y afectar la
              credibilidad institucional en cuestión de horas.
            </p>
            <p>
              Este escenario evidencia la necesidad de profesionales capaces de
              anticipar riesgos, interpretar datos y responder con mensajes
              claros, oportunos y éticos en entornos de alta incertidumbre.
            </p>
            <h3>
              Formación con enfoque <b>estratégico y digital </b>
            </h3>
            <p className="fontsize14">
              La Universidad Técnica Particular de Loja (UTPL), a través de la
              Tecnología en Comunicación Estratégica y Marketing Digital,
              responde formando profesionales preparados para
              <b>
                {" "}
                gestionar escenarios complejos y proteger la reputación
                institucional.
              </b>
            </p>
            <img src="https://tec.utpl.edu.ec/sites/default/files/2025-09/digital-marketing.png"></img>
            <p>Su modelo académico con una duración de 2 años integra:</p>{" "}
            <ul>
              <li>
                <p> Herramientas digitales</p>
              </li>
              <li>
                <p> Análisis de datos</p>
              </li>
              <li>
                <p>Monitoreo de medios</p>
              </li>
              <li>
                <p>Estrategias de contenido</p>
              </li>
            </ul>
            <p>
              Estos pilares permiten que los estudiantes desarrollen
              competencias para planificar, ejecutar y evaluar acciones
              comunicacionales de manera estratégica, especialmente en contextos
              críticos.
            </p>
            <br></br>
            <center>
              <a
                className="button"
                href="https://matriculas.utpl.edu.ec/authentication/login"
              >
                {" "}
                Matricúlate ahora
              </a>
            </center>{" "}
          </div>

          <div className="layout6 lightbluebg padding icon300">
            <center>
              <h3>
                {" "}
                <b>
                  {" "}
                  Voces expertas: <br></br>
                </b>{" "}
                comunicar con estrategia, ética y propósito
              </h3>{" "}
            </center>
            <BlockLeftImage
              src="https://tec.utpl.edu.ec/sites/default/files/2025-09/fanny_paladines.png"
              content={
                <>
                  <p>
                    La comunicación estratégica es clave porque permite a las
                    organizaciones proteger su reputación y mantener la
                    confianza de sus públicos en momentos de alta incertidumbre.
                    En una crisis, no comunicar o hacerlo de forma improvisada
                    puede agravar la situación, especialmente en entornos
                    digitales donde la información se amplifica rápidamente.
                  </p>
                  <p>
                    <b>Fanny Paladines</b>
                  </p>
                  <p>
                    Tecnología en Comunicación Estratégica y Marketing Digital
                    de la UTPL
                  </p>
                  <a
                    href="https://investigacion.utpl.edu.ec/fypaladines"
                    className="link-with-arrow"
                  >
                    {" "}
                    Ver perfil
                  </a>
                </>
              }
            ></BlockLeftImage>
          </div>

          <div className="layout6 margin">
            <h3>
              Decisiones basadas en <b> evidencia</b>
            </h3>
            <p>
              {" "}
              Un componente esencial de la formación es la toma de decisiones
              basada en datos. A través del análisis de métricas digitales,
              indicadores de reputación y evaluación de audiencias, los
              estudiantes aprenden a:
            </p>{" "}
            <ul>
              {" "}
              <li>
                {" "}
                <p> Medir impactos en tiempo real</p>
              </li>
              <li>
                {" "}
                <p> Ajustar mensajes según la evolución del contexto</p>
              </li>
              <li>
                {" "}
                <p> Comprender el comportamiento de los públicos</p>
              </li>
            </ul>
            <p>
              Este enfoque reduce la improvisación y fortalece la efectividad de
              las respuestas comunicacionales, permitiendo una gestión más
              sólida y coherente de las crisis.
            </p>
            <h3>
              {" "}
              La ética como <b> eje transversal</b>
            </h3>
            <p>
              {" "}
              La ética constituye un principio indispensable para comunicar con
              transparencia, responsabilidad y respeto por las personas. La UTPL
              promueve una comunicación estratégica consciente de su impacto
              social, aplicable tanto en:
            </p>
            <ul>
              {" "}
              <li>
                <p> Entornos corporativos</p>
              </li>
              <li>
                <p> Instituciones públicas</p>
              </li>
              <li>
                <p> Organizaciones sociales</p>
              </li>
              <li>
                <p> Proyectos comunitarios</p>
              </li>
            </ul>
            <p>
              En estos espacios, la confianza se construye —y se pone a prueba—
              especialmente en momentos críticos.
            </p>
            <h3>
              {" "}
              Compromiso con la <b>sociedad</b>{" "}
            </h3>
            <p>
              De esta manera, la UTPL refuerza su compromiso con la formación de
              comunicadores estratégicos, analíticos y éticos, preparados para
              responder a los desafíos de un entorno digital cambiante y
              exigente. A través de una propuesta académica alineada con las
              necesidades del país y de la sociedad, la universidad continúa
              aportando al fortalecimiento de la comunicación responsable, la
              protección de la reputación institucional y la construcción de una
              sociedad mejor informada y confiable.
            </p>
          </div>
        </article>

        <center>
          <h2> ¿Interesado en nuestra oferta? </h2>
          <a className="button" href="https://matriculas.utpl.edu.ec/authentication/login"> Matricúlate ahora</a>
 <br></br>
          <a
            className="link-with-arrow"
            href="https://utpl.edu.ec/tecnologia-comunicacion"
          >
            {" "}
            Conoce más información
          </a>
          <br></br>
          <h4>Comparte esta noticia</h4>

          <SocialShare
            title="Estudia una tecnología que transforma la comunicación institucional"
            url="https://utpl.edu.ec/transforma-la-comunicacion-institucional"
            imageUrl="https://noticias.utpl.edu.ec/sites/default/files/nota-especializaciones.png"
          >
            {" "}
          </SocialShare>
        </center>
      </div>

      <BannerGeneral></BannerGeneral>

      <script>
        var metaImg = document.createElement('meta');
        metaImg.setAttribute('property', 'og:image'); metaImg.content =
        'https://noticias.utpl.edu.ec/sites/default/files/nota-especializaciones.png';
        document.getElementsByTagName('head')[0].appendChild(metaImg); var
        metaTitle = document.createElement('meta');
        metaTitle.setAttribute('property', 'og:title'); metaTitle.content = '
        ¿Por qué los médicos deben especializarse en Imagenología y
        Anestesiología?';
        document.getElementsByTagName('head')[0].appendChild(metaTitle);
      </script>
    </>
  );
}

export default TecEstrategica;
